import Dashboard from '../views/Dashboard'
import Operators from '../views/settings/Operators'
import Banks from '../views/settings/Banks'
import Currencies from '../views/settings/Currencies'
import Roles from '../views/settings/Roles'
import Rights from '../views/settings/Rights'
import AccountInconsistency from '../views/inconsistency/AccountInconsistency'
import RaisingInconsistency from '../views/inconsistency/RaisingInconsistency'
import ServiceInconsistency from '../views/inconsistency/ServiceInconsistency'
import RaisingCategories from "../views/raisings/RaisingCategories"
import BankTransfers from "../views/transactions/BankTransfers"

export default [
  {
    path: '/dashboard',
    name: 'dashboard',
    component: Dashboard,
  },
  {
    path: '/transactions/bank-transfers',
    name: 'transactions.bank_transfers',
    component: BankTransfers,
  },
  {
    path: '/raisings/categories',
    name: 'raisings.categories',
    component: RaisingCategories,
  },
  {
    path: '/settings',
    name: 'settings',
    redirect: '/settings/operators',
    component: {
      render(c) {
        return c('router-view')
      }
    },
    children: [
      {
        path: 'operators',
        name: 'settings.operators',
        component: Operators,
      },
      {
        path: 'banks',
        name: 'settings.banks',
        component: Banks,
      },
      {
        path: 'currencies',
        name: 'settings.currencies',
        component: Currencies,
      },
      {
        path: 'roles',
        name: 'settings.roles',
        component: Roles,
      },
      {
        path: 'rights',
        name: 'settings.rights',
        component: Rights,
      },
    ]
  },
  {
    path: '/inconsistency',
    name: 'inconsistency',
    redirect: '/inconsistency/services',
    component: {
      render(c) {
        return c('router-view')
      }
    },
    children: [
      {
        path: 'accounts',
        name: 'inconsistency.accounts',
        component: AccountInconsistency,
      },
      {
        path: 'raisings',
        name: 'inconsistency.raisings',
        component: RaisingInconsistency,
      },
      {
        path: 'services',
        name: 'inconsistency.services',
        component: ServiceInconsistency,
      },
    ]
  },
]
